<template>
    <div>

        <vx-card titleIcon="FilterIcon" title="Advanced Filters">
            <div class="vx-row mt-2">
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
                    <label class="text-sm opacity-100 text-bold">General</label>
                    <vs-input class="w-full" v-model="filters['search']"></vs-input>
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
                    <label class="text-sm opacity-100 text-bold">View By Sundry Stock Status</label>
                    <v-select :clearable="true" placeholder="" v-model="filters['status']" multiple
                        :options="['In_Stock', 'Out_of_Stock', 'Expired']" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                </div>
                <!-- <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
                    <label class="text-sm opacity-100 text-bold">Shelf Life</label>
                    <v-select :clearable="true" placeholder="" @input="onSelectCustomFilter" label="key"
                        :options="custom_filter_options" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.value"></v-select>
                </div> -->
            </div>
            <div class="vx-row mb-4 hidden">
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Manufacturing Date From</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['manufacture-from']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['manufacture-from']"
                        placeholder="Choose Date" />
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Manufacturing Date To</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['manufacture-to']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['manufacture-to']"
                        placeholder="Choose Date" />
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Expiry Date From</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['expiry-to']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['expiry-to']"
                        placeholder="Choose Date" />
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Expiry Date To</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['expiry-to']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['expiry-to']"
                        placeholder="Choose Date" />
                </div>
            </div>
            <!-- <div class="vx-row mt-5">
                <div class="vx-col w-full ml-auto">
                    <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                        v-on:click="filters = {}">CLEAR</vs-button>
                </div>
            </div> -->
        </vx-card>
        <vx-card class="mt-4">
            <div class="vx-row">
                <div class="vx-col w-full">

                    <div slot="no-body" class="mt-4">
                        <vs-table id="sundry-item-list-table" :max-items="(meta.per_page) ? meta.per_page : 10"
                            :data="items" sort :sst="true" stripe
                            class="table-dark-inverted table-auto vs-con-loading__container">

                            <template slot="thead">
                                <vs-th width="15%" class="text-sm">BATCH NO</vs-th>
                                <vs-th width="10%" class="text-sm" sort-key="sundry_item_code">SUNDRY PRODUCT CODE</vs-th>
                                <vs-th width="10%" class="text-sm" sort-key="sundry_product_code">SUNDRY PRODUCT
                                    NAME</vs-th>
                                <vs-th width="5%" class="text-sm">LOCATION</vs-th>
                                <vs-th width="10%" class="text-sm">SUPPLIER</vs-th>
                                <vs-th width="10%" class="text-sm">TOTAL QTY (Kg)</vs-th>
                                <vs-th width="10%" class="text-sm">AVAILABLE QTY (Kg)</vs-th>
                                <vs-th width="10%" class="text-sm">STATUS</vs-th>
                                <vs-th width="10%" class="text-sm">ACTION</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr @click.native="onClickUpdateSundryStock(data[indextr])" class="text-sm"
                                    style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">


                                    <vs-td class="text-primary font-semibold" :data="data[indextr].code">
                                        {{ data[indextr].code || 'N/A' }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].sundry_item_code">
                                        {{ data[indextr].sundry_item_code }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].sundry_product_name">
                                        {{ data[indextr].sundry_product_name }}
                                    </vs-td>

                                    <vs-td>
                                        {{ data[indextr].location || 'N/A' }}
                                    </vs-td>

                                    <vs-td>
                                        {{ data[indextr].supplier }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].total_quantity">
                                        {{ data[indextr].total_quantity }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].available_quantity">
                                        {{ data[indextr].available_quantity }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].status">
                                        <vs-chip transparent :color="'dark'" style="border-radius: 0" class="w-32">
                                            {{ data[indextr].status | stock_status_format }}
                                        </vs-chip>
                                    </vs-td>


                                    <vs-td>
                                        <div class="vx-row">
                                            <vx-tooltip text="View/Update sundry stock" position="left" class="mr-2">
                                                <vs-button class="ml-3"
                                                    @click.stop="onClickUpdateSundryStock(data[indextr])" size="small"
                                                    color="warning" type="border" icon-pack="feather"
                                                    icon="icon-edit"></vs-button>
                                            </vx-tooltip>
                                            <vx-tooltip class="flex justify-start mr-2" text="View qc test" position="top">
                                                <vs-button class="flex justify-end"
                                                    @click.stop="onClickUpdateQcTest(data[indextr].q_c_test)" size="small"
                                                    color="primary" type="border" icon-pack="feather"
                                                    icon="icon-eye"></vs-button>
                                            </vx-tooltip>
                                        </div>
                                    </vs-td>

                                </vs-tr>
                            </template>


                        </vs-table>

                        <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
                            :max-items="perPage" description-body="Rows per page" description-connector="of"
                            description-title="Records" description :description-items="descriptionItems"
                            :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
                        </vs-pagination>


                    </div>

                </div>
            </div>
        </vx-card>
        <update-sundry-stock-pop-up v-on:refreshData="refreshData" ref="updateSundryStockPopUp" />
        <view-qc-test-sundry-order-item-pop-up ref="viewQcTestSundryOrderItemPopUp" />
    </div>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const InventoryRepository = RepositoryFactory.get('inventory')
import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import Filter from '@/mixins/filter';
import UpdateSundryStockPopUp from "@/components/popups/inventory/stock/sundry/UpdateSundryStockPopUp";
import ViewQcTestSundryOrderItemPopUp from '@/components/popups/sundry-suppliers/sundry-item-orders/qc-tests/ViewQcTestSundryOrderItemPopUp.vue'

const ManufacturingRepository = RepositoryFactory.get('manufacturing')
import { defaultPagination, perPageList } from "@/constants/config";

import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import moment from "moment";

export default {
    name: 'UpdateSundryItemStockPopUp',
    data() {
        return {
            open: false,
            id: '',
            items: [],
            filters: {},
            page: 1,
            total: 0,
            meta: {},
            sort: '',
            perPage: defaultPagination,
            descriptionItems: perPageList,
            createForm: '',
            sundry_item_code: '',
            custom_filter_options: [
                { key: '30-90 days short shelf life', value: 1 },
                { key: 'Less than 30 days to expiry', value: 2 },
                { key: 'Expired', value: 3 },
            ],
        }
    },
    async mounted() {
        await this.fetchSundryStockInventory()
    },
    methods: {
        async refreshData() {
            await this.fetchSundryStockInventory()
        },
        async fetchSundryStockInventory() {
            await this.$vs.loading({
                container: '#sundry-item-list-table',
                scale: 0.45
            })
            try {
                const { data } = await ManufacturingRepository.getSundryInventory(this.page, this.perPage, `${this.filterQuery}`)
                this.items = data.data
                this.meta = data.meta
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#sundry-item-list-table > .con-vs-loading')
        },
        onClickUpdateSundryStock(data) {
            this.$refs.updateSundryStockPopUp.openPopup(data.id)
        },
        async onClickUpdateQcTest(data) {
            await this.$refs.viewQcTestSundryOrderItemPopUp.openPopup(data)
        },
        filterQueryUpdate() {
            this.fetchSundryStockInventory()
        },

        handleChangePage(page) {
            this.page = page;
            this.fetchSundryStockInventory()
        },
        handleSort(key, active) {
            if (key) {
                active = (active === 'desc') ? "-" : '';
                this.sort = active + key;
                this.fetchSundryStockInventory()
            }

        },
        changePage(index) {
            this.perPage = this.descriptionItems[index]
        },
        toFixed(number) {
            return number
            // return Number(number).toFixed(4)
        },
        closePopup() {
            this.open = false
        },
        onSelectCustomFilter(value) {
            const today = moment().format('DD/MM/YYYY');
            let expiryFrom = '';
            let expiryTo = '';
            let status = 'In_Stock'

            if (value === 1) {
                expiryFrom = moment(today, 'DD/MM/YYYY').add(30, 'days').format('DD/MM/YYYY');
                expiryTo = moment(today, 'DD/MM/YYYY').add(90, 'days').format('DD/MM/YYYY');
            } else if (value === 2) {
                expiryFrom = today;
                expiryTo = moment(today, 'DD/MM/YYYY').add(30, 'days').format('DD/MM/YYYY');
            } else if (value === 3) {
                // expiryTo = today;
                status = 'Expired'
            }
            this.filterQuery = ''
            this.filterQuery += `&filter[expiry-from]=${expiryFrom}&filter[expiry-to]=${expiryTo}&filter[status]=${status}`;
            this.page = 1
            this.fetchSundryStockInventory();
        }
    },
    async mounted() {

    },
    components: {
        'v-select': vSelect,
        flatPickr,
        UpdateSundryStockPopUp,
        ViewQcTestSundryOrderItemPopUp
    },
    mixins: [SuccessMessage, ErrorMessages, Filter],
    watch: {
        page() {
            this.fetchSundryStockInventory()
        },
        perPage() {
            this.fetchSundryStockInventory()
        },
    }
}
</script>
  
<style scoped></style>
  